<template>
  <app-guest>
    <v-container fill-height>
      <v-row>
        <v-col cols="12">
          <v-card class="mx-auto" max-width="400px" style="box-shadow: none">
            <v-card-title class="justify-center" style="margin-bottom:30px">
              <img width="45%" src="../../assets/nuren-logo.png" alt="">
              <span style="transform:rotate(45deg)">+</span>
              <img width="45%" src="../../assets/firebase-logo.png" alt="">
            </v-card-title>
            <v-card-subtitle class="text-center">
              {{ $t('sign_in_to_your_account') }}
            </v-card-subtitle>

            <v-card-text>
              <login-form @success="success"></login-form>
            </v-card-text>
          </v-card>

          <br>
          <!-- <div class="text-center white--text">
            {{ $t('dont_have_account') }} <router-link class="info--text" :to="{ name: 'register' }">{{ $t('register') }}</router-link>
          </div> -->
        </v-col>
      </v-row>
    </v-container>
  </app-guest>
</template>

<script>
import LoginForm from './loginForm' 

export default {
  components: {
    LoginForm,
    AppGuest: () => import('@/components/core/AppGuest')
  },
  methods: {
    success(data) {
      this.$store.dispatch('auth/saveToken', data.token)
      this.$store.dispatch('auth/setUser', data.user)
      sessionStorage.setItem("user", data.user);
      this.$router.push({ name: 'dashboard' })      
    },
    fail(data)
    {
      this.$toastr.e(data);
    }
  }
}
</script>